import styles from './MentionsLegalesPage.module.css';
import { useTranslation } from '../hooks/useTranslation';

function MentionsLegalesPage() {
  const { t } = useTranslation();
  
  return (
    <div className={styles.page}>
      <h1>{t('legal.title')}</h1>
      <p className={styles.lastUpdate}>{t('legal.lastUpdate')}</p>

      <div className={styles.section}>
        <h2>{t('legal.editor.title')}</h2>
        <p>
          <strong>{t('legal.editor.name')}</strong><br />
          {t('legal.editor.editor')} <strong>{t('legal.editor.editorName')}</strong><br />
          {t('legal.editor.country')}<br />
          {t('legal.editor.email')} <a href="mailto:cheriecoiffer@gmail.com">cheriecoiffer@gmail.com</a>
        </p>
      </div>

      <div className={styles.section}>
        <h2>{t('legal.hosting.title')}</h2>
        <p>{t('legal.hosting.text')}</p>
        <p>
          <strong>{t('legal.hosting.provider')}</strong><br />
          {t('legal.hosting.address')}
        </p>
      </div>

      <div className={styles.section}>
        <h2>{t('legal.purpose.title')}</h2>
        <p dangerouslySetInnerHTML={{ __html: t('legal.purpose.description') }} />
        <ul>
          {t('legal.purpose.items').map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <p>{t('legal.purpose.goal')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('legal.profiles.title')}</h2>

        <h3>{t('legal.profiles.public.title')}</h3>
        <p dangerouslySetInnerHTML={{ __html: t('legal.profiles.public.text') }} />
        <ul>
          {t('legal.profiles.public.items').map((item, index) => (
            <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </ul>

        <p>{t('legal.profiles.public.privacy')}</p>

        <h3>{t('legal.profiles.rights.title')}</h3>
        <p>{t('legal.profiles.rights.text')}</p>
        <ul>
          {t('legal.profiles.rights.items').map((item, index) => (
            <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </ul>

        <p>
          {t('legal.profiles.rights.contact')}{' '}
          <a href="mailto:cheriecoiffer@gmail.com">cheriecoiffer@gmail.com</a>.
          {' '}{t('legal.profiles.rights.deletion')}
        </p>
      </div>

      <div className={styles.section}>
        <h2>{t('legal.accounts.title')}</h2>
        <p>{t('legal.accounts.text')}</p>
        <ul>
          {t('legal.accounts.items').map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <p>{t('legal.accounts.responsibility')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('legal.data.title')}</h2>
        <p>{t('legal.data.text1')}</p>
        <p>{t('legal.data.text2')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('legal.gdpr.title')}</h2>
        <p>{t('legal.gdpr.text')}</p>
        <ul>
          {t('legal.gdpr.items').map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <p>
          {t('legal.gdpr.contact')} <a href="mailto:cheriecoiffer@gmail.com">cheriecoiffer@gmail.com</a>
        </p>
      </div>

      <div className={styles.section}>
        <h2>{t('legal.intellectual.title')}</h2>
        <p dangerouslySetInnerHTML={{ __html: t('legal.intellectual.text') }} />
      </div>

      <div className={styles.section}>
        <h2>{t('legal.liability.title')}</h2>
        <p>{t('legal.liability.text')}</p>
        <ul>
          {t('legal.liability.items').map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div className={styles.section}>
        <h2>{t('legal.contact.title')}</h2>
        <p>
          {t('legal.contact.text')}{' '}
          <a href="mailto:cheriecoiffer@gmail.com">cheriecoiffer@gmail.com</a>
        </p>
      </div>
    </div>
  );
}

export default MentionsLegalesPage;
